/**
 * Created by Omar Jaime Bonilla Venegas on 2017-06-13.
 * Provides general components for this container
 */
import Item from './item';

export { Item };



// WEBPACK FOOTER //
// ./containers/proveedores/components/index.js